// index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './setupAuthInterceptors'; // installs token-attaching axios/fetch interceptors
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

reportWebVitals();
